"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventValidationService = void 0;
var ajv_1 = __importDefault(require("ajv"));
var EventValidationService = /** @class */ (function () {
    function EventValidationService(_a) {
        var timberService = _a.timberService, commonSectionSchemas = _a.commonSectionSchemas;
        var _this = this;
        this.ajv = new ajv_1.default();
        if (timberService) {
            this.timberService = timberService;
        }
        commonSectionSchemas.forEach(function (commonSchema) { return _this.ajv.addSchema(commonSchema); });
    }
    EventValidationService.prototype.validateEventSchema = function (eventName, event, eventId, eventSchema) {
        var _a, _b, _c, _d;
        var logParams = {
            module: 'validateEventSchema',
            extendedParameters: { eventName: eventName, event: event, eventId: eventId, sessionId: event.systemHeader.sessionId }
        };
        var result = { success: false };
        try {
            if (eventSchema) {
                var validate = this.ajv.compile(eventSchema);
                var valid = validate(event);
                if (valid) {
                    (_a = this.timberService) === null || _a === void 0 ? void 0 : _a.info("Event ".concat(eventName, " ").concat(eventId, " was validated successfully."), logParams);
                    result.success = true;
                    return result;
                }
                var errorMessage = "Failed to validate eventSchema ".concat(JSON.stringify(validate.errors).replace("#", ""));
                (_b = this.timberService) === null || _b === void 0 ? void 0 : _b.error(errorMessage, logParams);
                result.error = new Error(errorMessage);
            }
            else {
                var errorMessage = "EventSchema parameter didn't initialized for ".concat(eventName, " ").concat(eventId);
                (_c = this.timberService) === null || _c === void 0 ? void 0 : _c.error(errorMessage, logParams);
                result.error = new Error(errorMessage);
            }
            return result;
        }
        catch (e) {
            var errorMessage = "Failed to validateEventSchema ".concat(JSON.stringify(e).replace("#", ""));
            (_d = this.timberService) === null || _d === void 0 ? void 0 : _d.error(errorMessage, logParams);
            result.error = new Error(errorMessage);
            return result;
        }
    };
    return EventValidationService;
}());
exports.EventValidationService = EventValidationService;
